import { defineMeta } from '@/registry/types';

export const autocompleteMeta = defineMeta({
  name: 'Autocomplete',
  level: 'molecule',
  category: 'input',
  classification: 'themed-mui',
  description: 'Searchable combobox for selecting from many options. Themed MUI Autocomplete.',
  baseLibrary: '@mui/material',
  muiEquivalent: 'Autocomplete',
  muiDocs: 'https://mui.com/material-ui/react-autocomplete/',
  a2uiEquivalent: 'Combobox',
  importPath: '@/molecules/Autocomplete',
  requiredProps: ['options', 'renderInput'],
  optionalProps: ['multiple', 'value', 'onChange', 'freeSolo', 'groupBy', 'loading', 'disabled'],
  supportedStates: ['default', 'open', 'loading', 'multiple', 'disabled'],
  designTokens: ['colors', 'radius'],
  accessibility: ['Renders an ARIA combobox; ensure renderInput uses a labeled TextField.'],
  usageExamples: ['<Autocomplete options={opts} renderInput={(p) => <TextField {...p} label="Region" />} />'],
  antiPatterns: ['Do not use for very small static lists (use Select/Radio).'],
  llmSafe: true,
  whenToUse: ['Searchable selection, tagging, async options'],
  whenNotToUse: ['Few fixed options'],
});

export default autocompleteMeta;
